module.exports = __webpack_public_path__ + "img/1-1.02f5d4a2.png";